import { ConfirmationModalSettings, InformationModalSettings, ColourVariantType, ModalConstants, NotificationModel } from '@/types';
import MStoreNotification from '@/components/shared/MStoreNotification.vue';
import ApiKeyDisplayModal from '@/components/shared/ApiKeyDisplayModal.vue';
import { BvModal } from 'bootstrap-vue';

export const ModalHelpers = {
  methods: {
    async showConfirmationModalAsync(this: any, modal: any, message?: string, confirmationModalSettings?: ConfirmationModalSettings): Promise<boolean> {
      let confirmed: boolean = false;
      const text = confirmationModalSettings?.isHtml ? await this.getConfirmationHtmlMessage(message, confirmationModalSettings) : message ? message : 'Please confirm to proceed';
      await modal
        .msgBoxConfirm(text, {
          title: confirmationModalSettings?.title || 'Are you sure?',
          headerBgVariant: confirmationModalSettings?.headerBgVariant || ColourVariantType.Transparent,
          headerTextVariant: confirmationModalSettings?.headerTextVariant || ColourVariantType.Dark,
          okVariant: confirmationModalSettings?.okVariant || ColourVariantType.Danger,
          okTitle: confirmationModalSettings?.okTitle || ModalConstants.defaultConfirmationText,
          cancelVariant: confirmationModalSettings?.cancelVariant || ColourVariantType.Primary,
          cancelTitle: confirmationModalSettings?.cancelTitle || 'Cancel',
          scrollable: true
        })
        .then((result: boolean) => {
          confirmed = result;
        });
      return confirmed;
    },
    async showInformationModalAsync(this: any, modal: any, message: string, informationModalSettings?: InformationModalSettings): Promise<boolean> {
      let confirmed: boolean = false;
      const text = informationModalSettings?.showCheckBox
        ? await this.getInformationHtmlMessage(message, informationModalSettings)
        : informationModalSettings?.isHtml
        ? [this.$createElement('div', { domProps: { innerHTML: message } })]
        : message || 'Please confirm to proceed';
      await modal
        .msgBoxOk(text, {
          title: informationModalSettings?.title ? informationModalSettings.title : 'Are you sure?',
          buttonSize: 'md',
          centered: true,
          size: 'md',
          okVariant: informationModalSettings?.okVariant ? informationModalSettings.okVariant : ColourVariantType.Primary,
          okTitle: informationModalSettings?.okTitle ? informationModalSettings.okTitle : 'OK'
        })
        .then((result: boolean) => {
          confirmed = result;
        });
      return confirmed;
    },
    async getConfirmationHtmlMessage(this: any, message: string, confirmationModalSettings: ConfirmationModalSettings) {
      const element = this.$createElement;
      const checkBox = confirmationModalSettings.showCheckBox
        ? element('div', { class: ['row', 'm-1'] }, [
            element(
              'b-check',
              {
                on: { change: confirmationModalSettings.callBack }
              },
              [element('div', { class: ['mt-05'] }, [`Don't ask me again`])]
            )
          ])
        : null;
      const confirmationMessage = await [element('div', { domProps: { innerHTML: message } }), checkBox];
      return confirmationMessage;
    },
    async getInformationHtmlMessage(this: any, message: string, informationModalSettings: InformationModalSettings) {
      const element = this.$createElement;
      const checkBox = informationModalSettings.showCheckBox
        ? element('div', { class: ['row', 'm-1'] }, [
            element(
              'b-check',
              {
                on: { change: informationModalSettings.callBack }
              },
              [element('div', { class: ['mt-05'] }, [`Don't show this again`])]
            )
          ])
        : null;
      const messageContent = informationModalSettings?.isHtml ? 
        element('div', { domProps: { innerHTML: message } }) : 
        element('div', {}, [message]);
      const informationMessage = await [messageContent, checkBox];
      return informationMessage;
    },
    async showApiKeyModalAsync(this: any, modal: any, apiKey: string, title: string = 'API Key Generated'): Promise<boolean> {
      try {
        const apiKeyDisplayModal = this.$createElement(ApiKeyDisplayModal, { props: { apiKey } });
        let confirmed = false;

        await modal
          .msgBoxOk([apiKeyDisplayModal], {
            title,
            size: 'md',
            centered: true,
            headerBgVariant: 'primary',
            headerTextVariant: 'white',
            okTitle: 'Close',
            okVariant: 'primary',
            noCloseOnBackdrop: true,
            scrollable: true
          })
          .then((result: boolean) => {
            confirmed = result;
          });

        return confirmed;
      } catch (error) {
        console.error('Error in showApiKeyModalAsync:', error);
        throw error;
      }
    },
    async showNotificationModalAsync(this: any, notification: NotificationModel): Promise<boolean> {
      const messageVNode = this.$createElement(MStoreNotification, { props: { notification } });
      let userResponse = false;

      if (notification.hasErrorMessages) {
        await this.$bvModal.msgBoxOk([messageVNode], {
          size: 'lg',
          okTitle: 'Close',
          noCloseOnBackdrop: true,
          scrollable: true
        });
      } else if (notification.hasWarningMessages) {
        userResponse = await (this.$bvModal as BvModal).msgBoxConfirm([messageVNode], {
          size: 'lg',
          okTitle: 'Accept and Continue',
          okVariant: 'danger',
          cancelTitle: 'Cancel',
          cancelVariant: 'primary',
          noCloseOnBackdrop: true,
          scrollable: true
        });
      }

      return userResponse;
    }
  }
};
